export const getCurrentOrderList = (orderBy: "asc" | "desc" | string) => {
    if (orderBy === "asc") {
      return "desc";
    }

    return "asc";
  };